// App.js
import React, { useEffect } from 'react';
import './styles/App.css'
import { BrowserRouter } from 'react-router-dom';
import MainNavbar from "./components/MainNavbar";
import RoutesList from "./components/RoutesList";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Cookies from 'js-cookie';
import Auth from './pages/Auth';
import './i18n';
import { useTranslation } from 'react-i18next';
import { createTheme } from '@mui/material/styles';

// eslint-disable-next-line
import adapter from "webrtc-adapter";
import { host } from "./libs/webRTC";
import axios from "./libs/httpClient";
import { useUser } from './context/UserContext';
import get_main_theme from './themes'


export default function App() {
    const { t, i18n } = useTranslation();
    const userContext = useUser();
    let loadMode = Cookies.get('mode') || 'light';
    let loadLang = Cookies.get('lang') || 'ru';
    
    useEffect(() => {
        if (loadLang && loadLang !== i18n.language) i18n.changeLanguage(loadLang);
    }, [loadLang, i18n]);

    const [mode, setMode] = React.useState(loadMode ? loadMode : 'light');

    const changeMode = () => {
        Cookies.set('mode', mode === 'light' ? 'dark' : 'light');
        setMode(mode === 'light' ? 'dark' : 'light')
    }

    return (
        <ThemeProvider theme={get_main_theme(mode)}>
            <CssBaseline />
                {userContext.user ? (
                    <>
                        <MainNavbar changeMode={changeMode} mode={mode} />
                        <RoutesList />
                    </>
                ) : (
                    <>
                    <Auth />
                    </>
                )}
        </ThemeProvider>
    );
}
